import { createAction } from 'redux-actions';

export const updateProfileRequest = createAction('UPDATE_PROFILE_REQUEST');
export const updateProfileSuccess = createAction('UPDATE_PROFILE_SUCCESS');
export const updateProfileEndRequest = createAction(
  'UPDATE_PROFILE_END_REQUEST'
);
